<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-bandage" icon-small title="مدیریت استعلام ها" color="accent">
			<div cols="12" class="pa-5 pt-0">
				<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
					<v-tab :key="0">گزارش استعلام ها</v-tab>
					<v-tab :key="1">تنظیمات</v-tab>

					<v-tabs-items v-model="activeTab" touchless class="mt-3">
						<v-tab-item :key="0">
							<v-alert outlined v-if="!checkPermission('Inquiry') && area !== 'superadmin'" type="error">دسترسی به این بخش برای شما امکان پذیر نمی باشد</v-alert>
							<inquiry-list v-else :autoLoad="autoLoad" :area="area" />
						</v-tab-item>
						<v-tab-item :key="1" style="">
							<v-alert outlined v-if="!checkPermission('Inquiry') && area !== 'superadmin'" type="error">دسترسی به این بخش برای شما امکان پذیر نمی باشد</v-alert>
							<div v-else>
								<v-row v-if="area !== 'superadmin'" class="" style="position: sticky; top: 0;z-index: 2;">
									<v-col cols="12">
										<div class="text-left pa-3">
											<!-- <v-spacer/> -->
											<v-btn class="mr-2" color="blue" :loading="loading" dark @click="saveSettings()">
												ذخیره تنظیمات
											</v-btn>
										</div>
										<v-divider></v-divider>
									</v-col>
									<v-col cols="12" md="12" class="text-left">
										<v-form ref="inquiryForm" class="" lazy-validation>
											<v-card class="px-3 pb-5 mb-3" elevation="0">
												<v-row class="flex-column sms-row">
													<v-col cols="12" class="text-center">
														پنل مرجع استعلام ها را انتخاب نمایید:
													</v-col>
													<v-col cols="12" md="4" class="">
														<v-select v-model="appSettings.defaultInquiryPanel" clearable required :items="inquiryPanels" label="انتخاب پنل استعلام ها" single-line return-object item-text="title" item-value="id" />
													</v-col>
													<v-col cols="12">
														<v-row v-if="appSettings.defaultInquiryPanel && appSettings.defaultInquiryPanel.id === 4">
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.finnoTechConfig.clientId" label="ClientId" :error-messages="errorMessages" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.finnoTechConfig.nId" label="NId" :error-messages="errorMessages" />
															</v-col>
															<v-col cols="12" md="4">
																<v-text-field class="left-input" v-model="appSettings.finnoTechConfig.clientSecret" label="clientSecret" :error-messages="errorMessages" />
															</v-col>
														</v-row>
														<v-row justify="center" v-if="appSettings.defaultInquiryPanel && appSettings.defaultInquiryPanel.id === 2">
															<v-col cols="12" md="10">
																<v-text-field class="left-input" v-model="appSettings.apiIRConfig.apiToken" label="توکن" />
															</v-col>
														</v-row>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="appSettings.defaultInquiryPanel && appSettings.defaultInquiryPanel.id === 1 && isCloud">
													<v-col cols="6" class="pb-0">
														<v-text-field class="center-input" :disabled="true" v-model="appSettings.inquiryCredit" label="اعتبار فعلی پنل استعلامی شما (تومان)" required />
													</v-col>
													<v-col cols="6" class="text-center pt-0">
														<v-btn class="mx-auto" color="secondary" dark @click="addInquiryCreditCharge">
															<v-icon dark>
																mdi-plus-circle-outline
															</v-icon>
															افزایش اعتبار
														</v-btn>
													</v-col>
												</v-row>

												<v-row class="flex-column sms-row" v-if="appSettings.defaultInquiryPanel && appSettings.defaultInquiryPanel.id !== 0">
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.verifyMobileByNationalCodeInRegister" label="بررسی مطابقت کد ملی با شماره موبایل در زمان ثبت نام فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.inquiryPersonInfoInRegister" label="اطلاعات هویتی کاربر توسط سیستم استعلام گیری انجام شود؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.inquiryPostalAddressInRegister" label="استعلام آدرس پستی در زمان ثبت نام فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
													<v-col cols="12" class="d-flex justify-center flex-column align-center">
														<v-switch v-model="appSettings.inquiryBankInRegister" label="استعلام شماره کارت بانکی در زمان ثبت نام فعال باشد؟" color="secondary" :value="true" hide-details></v-switch>
													</v-col>
												</v-row>

											</v-card>
										</v-form>
									</v-col>
								</v-row>
							</div>
						</v-tab-item>
					</v-tabs-items>
				</v-tabs>
			</div>
		</material-card>

		<confirm-dlg ref="confirm" />

		<div class="py-3" />

		<v-dialog v-model="dialogInquiryCreditCharge" scrollable persistent max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">شارژ اعتبار پنل استعلام</span></div>
					<v-spacer />
					<v-btn @click="dialogInquiryCreditCharge = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<inquiry-credit-charge ref="inquiryCreditCharge" v-if="dialogInquiryCreditCharge" @callbck="callbck_inquiryCreditCharge" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import { call, get } from 'vuex-pathify'

	export default {
		name: 'MembersView',
		props: {
			autoLoad: { type: Boolean, default: true },
			area: { type: String, default: 'admin' },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-picker': VuePersianDatetimePicker,
			'date-navigator': () => import('@/components/DateNavigator'),
			'inquiry-credit-charge': () => import('@/components/forms/InquiryCreditCharge.vue'),
			'inquiry-list': () => import('./InquiryList.vue'),
		},
		data() {
			return {
				dialogInquiryCreditCharge: false,
				errorMessages: '',
				appSettings: { dashboardSettings: {} },
				activeTab: 0,
				loading: false,
				rowLoading: '',
				inquiryPanels: []
			}

		},
		computed: {
			...get('siteConfig', [
				'isCloud'
			]),
		},
		created() {

		},
		mounted() {
			if (this.isCloud) {
				this.inquiryPanels.push(...[{ id: 0, title: 'انتخاب نشده' }, { id: 1, title: 'جت اقساط' }])
			} else {
				this.inquiryPanels.push(...[{ id: 0, title: 'انتخاب نشده' }, { id: 2, title: 'api.ir' }, { id: 4, title: 'فینوتک' }, { id: 6, title: 'شاهین' }])
				this.loadAppSettings(false)
			}
		},
		methods: {
			...call('appSettings/*'),
			saveSettings() {
				this.loading = true
				var data = _.cloneDeep(this.appSettings)
				data.verifyMobileByNationalCodeInRegister = !!data.verifyMobileByNationalCodeInRegister
				data.inquiryPersonInfoInRegister = !!data.inquiryPersonInfoInRegister
				data.inquiryPostalAddressInRegister = !!data.inquiryPostalAddressInRegister
				data.inquiryBankInRegister = !!data.inquiryBankInRegister
				if (this.appSettings.defaultInquiryPanel)
					data.defaultInquiryPanel = this.appSettings.defaultInquiryPanel.id
				this.sync(data).then(x => {
					this.loading = false
					toast.success('اطلاعات با موفقیت ذخیره شد.')
				}).catch(err => {
					this.loading = false
					toast.error(err.message)
				})
			},
			loadAppSettings(force) {
				this.fetch({ force: force }).then(x => {
					this.appSettings = x
					this.appSettings.defaultInquiryPanel = this.inquiryPanels.find(x => x.id == this.appSettings.defaultInquiryPanel)
				})
			},
			async addInquiryCreditCharge() {
				await this.saveSettings()
				this.dialogInquiryCreditCharge = true
			},
			callbck_inquiryCreditCharge() {
				this.dialogInquiryCreditCharge = false
			}
		},
	}
</script>
<style scoped>
	.sms-row {
		justify-content: center;
		align-items: center;
		background-color: whitesmoke;
		border-radius: 10px;
		margin: 15px 0;
		padding: 10px 0;
		border: 1px solid #dca6e5;
	}
</style>